export default __webpack_public_path__ + "static/media/popular_badge.5dff0ba1.png";